import React from "react";
import Table from "./Table";

const AllergiesTable = ({
  allergies,
  selectedAllergy,
  sortColumn,
  onSort,
  onSelect,
}) => {
  const columns = [
    {
      key: "select",
      content: (allergy) => (
        <input
          type="radio"
          className="ps-2"
          name={allergy.UID}
          checked={allergy.UID === selectedAllergy.UID}
          onClick={() => onSelect(allergy)}
        />
      ),
    },
    { path: "IdType", label: "Allergy Type" },
    { path: "Description", label: "Description" },
  ];

  return (
    <Table
      columns={columns}
      data={allergies}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default AllergiesTable;
